export enum EmploymentTypesActionTypesEnum {
  EMPLOYMENT_TYPES_ACTION_REQUEST = 'EMPLOYMENT_TYPES_ACTION_REQUEST',
  EMPLOYMENT_TYPES_ACTION_RESPONSE = 'EMPLOYMENT_TYPES_ACTION_RESPONSE',
  EMPLOYMENT_TYPES_ACTION_ERROR = 'EMPLOYMENT_TYPES_ACTION_ERROR',
}
